export enum PartnersSheetStatus {
  AcceptsFile = "accepts-file",
  Processing = "processing",
  Matching = "matching",
}
